module.exports = __webpack_public_path__ + "static/media/station_nyarutarama5.906fb2f8.jpeg";